function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g867",
    transform: "matrix(0.99964688,0,0,1.0003434,5.2292308e-5,-3.9186754e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18073",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313113px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.0787977,0.11239426 5.1829272,1.0389777 M 0.15026792,0.14901143 H 4.0265153 V 1.0756068 H 5.1306449 V 6.4483077 H 0.15026792 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18485",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.295856,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "M 1.8379622,4.8578297 A 0.23268304,0.38559406 59.198298 0 1 1.6215387,5.2550951 0.23268304,0.38559406 59.198298 0 1 1.173268,5.249143 0.23268304,0.38559406 59.198298 0 1 1.3896916,4.8518657 a 0.23268304,0.38559406 59.198298 0 1 0.4482706,0.00595 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: "0.313113px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 1.8379622,4.8578297 V 2.8665746 L 3.1343388,2.1092324 V 4.20203",
    id: "path18487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18489",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.295856,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "M 3.1508094,4.1556038 A 0.23268304,0.38559406 59.198298 0 1 2.9343858,4.552881 0.23268304,0.38559406 59.198298 0 1 2.4861152,4.546929 0.23268304,0.38559406 59.198298 0 1 2.702527,4.1496517 a 0.23268304,0.38559406 59.198298 0 1 0.4482824,0.00595 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOn);
export default __webpack_public_path__ + "static/media/music_on.3137e624c83a93a09025cc979ff0aa0e.svg";
export { ForwardRef as ReactComponent };